<template>
  <div>
    <div class="row adm-wrp">
      <div class="col-3 text-left">
        {{ adminObj.email }}
      </div>
      <div class="col-3 text-left">
        {{ adminObj.user_name }}
      </div>
      <div v-if="!adminObj.super_admin" class="col-4 text-right">
        <div v-if="!edit" class="row">
          <div
            class="chip"
            :key="index"
            v-for="(perm, index) in adminObj.admin_permissions"
          >
            {{ ADMIN_ACTION[perm] }}
          </div>
        </div>
        <div v-else>
          <v-select
            v-model="admin_permissions"
            :items="actions"
            solo
            outline
            chips
            label="Permissions"
            multiple
            item-text="name"
            item-value="value"
            append-outer-icon="mdi-close"
            @click:append-outer="edit = false"
          >
          </v-select>
        </div>
      </div>
      <div v-if="!adminObj.super_admin" class="col-2">
        <v-icon v-if="!edit" @click="editAdmin" class="icon-class-info"
          >mdi-pencil</v-icon
        >
        <v-icon
          v-else
          @click="saveAdmin"
          style="margin-left: 3rem"
          class="icon-class-save"
          >mdi-check</v-icon
        >
      </div>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right: 1rem"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { IsEmptyObject } from "../../../globalFunctions";
import { ADMIN_ACTION } from "../../../globalConstants";
import { UPDATE_ADMIN } from "../../../Api/admin_api";
export default {
  name: "admin-card",
  props: {
    admin: Object,
    adminActions: Object,
  },
  data: function () {
    return {
      timeOut: 1000,
      bgColor: "#454545",
      snackbar: false,
      snackMessage: "",
      snackIcon: "",
      adminObj: {},
      EmptyObject: IsEmptyObject,
      ADMIN_ACTION: ADMIN_ACTION,
      edit: false,
      admin_permissions: [],
      actions: [],

    };
  },
  methods: {
    editAdmin() {
      const self = this;
      self.edit = true;
    },
    saveAdmin() {
      const self = this;
      let data = {
        user_id: self.adminObj.user_id,
        admin_permissions: self.admin_permissions,
        operation: "add",
      };
      UPDATE_ADMIN(data)
        .then(function (response) {
          self.edit = false;
          self.$emit('save-admin', response.message)
        })
        .catch(function (error) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.response.data.title;
        });
    },
  },
  mounted() {
    const self = this;
    if (!self.EmptyObject(self.admin)) {
      self.adminObj = self.admin;
      self.admin_permissions = self.admin.admin_permissions;
    }
    if (!IsEmptyObject(self.adminActions)) {
      for (let key in self.adminActions) {
        let obj = {
          name: key,
          value: self.adminActions[key],
        };
        self.actions.push(obj);
      }
    }
  },
};
</script>

<style scoped>
.adm-wrp {
  background-color: #fafafa;
  padding: 2rem !important;
  border-bottom: 0.1rem solid #e4e4e4;
  margin: 1rem !important;
}
.chip {
  padding: 0.5rem 1rem;
  background-color: var(--button-color);
  color: white;
  margin: 1rem 0.5rem;
  border-radius: 0.5rem;
}
</style>